import * as React from 'react';
import {Button, ButtonGroup, Col} from 'reactstrap';
import renderSelectField from '../../../theme/components/form/Select';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import validate from './validate';
import Panel from '../../../theme/components/Panel';

class AlmacenForm extends React.PureComponent<InjectedFormProps> {

    public render() {
        const {handleSubmit, resumenDiario} = this.props;
        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <Col md={12}>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Ruta</label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='rutaId'
                                    component={renderSelectField}
                                    placeholder='Seleccione'
                                    type='text'
                                    options={resumenDiario.map((res) => {
                                        return {value: res.ruta.id, label: res.ruta.descripcion}
                                    })}
                                />
                            </div>
                        </div>
                    </Col>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>
                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'almacen_form', // a unique identifier for this form
    validate,
})(AlmacenForm);


// WEBPACK FOOTER //
// ./src/components/pages/almacen/almacen-form.tsx